import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-date-time-picker',
  templateUrl: './date-time-picker.component.html',
  styleUrls: ['./date-time-picker.component.scss'],
  standalone: false
})
export class DateTimePickerComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
